import React, {useState} from 'react';
import Helmet from "react-helmet";
import {config} from "../../config";
import {useBreakpoint} from "../../libs/breakpoint";
import _ from "lodash";
import {canonical} from "../../libs/helper";
import createLink from "../../libs/createLink";

export const ComparatorDating = (props) => {
    const [heightIframe, setHeightIframe] = useState(6000);

    window.addEventListener('message', function(event) {
        if (event.origin !== "https://tools.emstat.fr")
            return;
        let newHeight = event.data.height;
        if(event.origin === "https://tools.emstat.fr" && heightIframe !== newHeight){
            setHeightIframe(newHeight)
        }

    }, false);

    window.scrollTo(0, 0);

    const breakpoints = useBreakpoint();
    let search = _.get(props,"location.search") || "";
    let urlIframe = breakpoints.md ? `https://tools.emstat.fr/voissa/comparateur-dating-mobile.php${search}` : `https://tools.emstat.fr/voissa/comparateur-dating-desktop.php${search}`;

    return (
        <div id="comparator-dating">
            <Helmet>
                <title>{config.preTitle}Comparateur des meilleurs sites de rencontres{config.postTitle}</title>
                <meta name="robots" content="noindex,nofollow" />
                <link rel="canonical" href={canonical(createLink('comparatorDating'), "", "comparatorDating")} />
            </Helmet>
            <div className="container">
                <div className="card big">
                    <iframe
                        title="Comparateur des meilleurs sites de rencontres"
                        src={urlIframe}
                        height={`${heightIframe}px`}
                        width="100%"
                        style={{border:"none", 'overflow-y' : 'hidden', height: breakpoints.md ? `${heightIframe}px` : `${heightIframe}px`}}
                    />
                </div>
            </div>
        </div>
    )


};
export default ComparatorDating;